var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSetting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0784 21V11M12.0784 11C10.3701 11 8.98527 9.65686 8.98527 8.00001C8.98527 6.34316 10.3701 5 12.0784 5M12.0784 11C13.7866 11 15.1715 9.65686 15.1715 8.00001C15.1715 6.34316 13.7866 5 12.0784 5M12.0784 3V5M4.9681 3L4.9681 13M4.9681 13C3.25982 13 1.875 14.3431 1.875 16C1.875 17.6568 3.25982 19 4.9681 19M4.9681 13C6.67637 13 8.0612 14.3431 8.0612 16C8.0612 17.6568 6.67637 19 4.9681 19M4.9681 21V19M19.0319 3V11.0547M19.0319 11.0547C17.3236 11.0547 15.9388 12.3979 15.9388 14.0547C15.9388 15.7116 17.3236 17.0547 19.0319 17.0547M19.0319 11.0547C20.7402 11.0547 22.125 12.3979 22.125 14.0547C22.125 15.7116 20.7402 17.0547 19.0319 17.0547M19.0319 21V17.0547",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.4612c1519449890ce45bada54d5708f7.svg";
export { ForwardRef as ReactComponent };